<div class="disabilitato__container">
    <div class="disabilitato__wrapper">
        <span class="material-symbols-outlined icon">
            report
        </span>
        <div class="title">
            Modulo <span class="powered__color">{{pagina}}</span> disabilitato
        </div>
        <div class="subtitle">
            Per maggiori informazioni contatta Cantine<span class="powered__color">.wine</span>
        </div>
    </div>
</div>